export class ConfirmModel {
    objectId: string;
    reason: string;
}
